export const maskMobileNumber = (mobileNumber) => {
    if (!mobileNumber) return '';
    let maskedNumber = ''
    if (mobileNumber.length) {
        if (mobileNumber.length > 2 && mobileNumber.length <= 5) {
            // Too short to reveal both the first 2 and last 3 digits without
            // exposing the whole number (or overlapping), so mask the rest.
            maskedNumber = mobileNumber.substring(0, 2) + '*'.repeat(mobileNumber.length - 2);
        } else if (mobileNumber.length > 5) {
            // Covers 10-digit domestic numbers as well as shorter (6-9 digit)
            // and longer foreign numbers alike: first 2 digits, masked middle,
            // last 3 digits.
            const firstTwoDigits = mobileNumber.slice(0, 2);
            const lastThreeDigits = mobileNumber.slice(-3);
            const middleDigitsCount = mobileNumber.length - firstTwoDigits.length - lastThreeDigits.length;
            const maskedMiddle = '*'.repeat(middleDigitsCount);
            maskedNumber = `${firstTwoDigits}${maskedMiddle}${lastThreeDigits}`;
        } else {
            maskedNumber = mobileNumber.substring(0, 2);
        }
    }
    return maskedNumber;
};